import { Loading } from 'module/ui/components/atoms/loading';
import { useQuery } from '@tanstack/react-query';
import { CitationAPI } from 'api/citation';
import { CitationResponse } from 'queries/citation';
import styled from 'styled-components';
import {
  Label,
  CitationDataPopoverContainer,
  StyledLoader,
} from './shared-styles';

const UrlLink = styled.a`
  font-size: var(--font-size-md);
  text-decoration: underline;
  word-break: break-all;
  margin: 0 var(--spacing-05) var(--spacing-04) var(--spacing-05);
  &:hover {
    text-decoration: underline;
  }
`;

const ALLOWED_CONTENT_TYPES = ['WEBSITE', 'API_DOC'];

interface CitationDataPopoverProps {
  citationId: number;
}

export const CitationKnowledgeDocumentPopover: React.FC<
  CitationDataPopoverProps
> = ({ citationId }) => {
  const { data, isFetching } = useQuery<CitationResponse, Error>({
    queryKey: ['rl-citation', citationId],
    queryFn: () => CitationAPI.getCitation(citationId),
  });

  const documentTitle = data?.metaData?.documentTitle;
  const url = data?.metaData?.url;
  const contentType = data?.metaData?.contentType;
  const showUrl =
    url && contentType && ALLOWED_CONTENT_TYPES.includes(contentType as string);

  return (
    <>
      {isFetching ? (
        <StyledLoader>
          <Loading />
        </StyledLoader>
      ) : (
        <CitationDataPopoverContainer>
          {documentTitle && <Label>{documentTitle}</Label>}
          {showUrl && (
            <UrlLink
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {url}
            </UrlLink>
          )}
        </CitationDataPopoverContainer>
      )}
    </>
  );
};
